module.exports = __webpack_public_path__ + "img/Skirt-Back-B8-Da-Fb.dbacd7bf.png";